import { PERMISSIONS_OPTIONS_VALUE } from 'constants/team-members';

const { EDITOR, VIEW_ONLY, NO_ACCESS } = PERMISSIONS_OPTIONS_VALUE;

export const TEAM_MEMBERS_PERMISSIONS = {
  [VIEW_ONLY]: {
    HIDE_CREATE_MEMBER: true,
    HIDE_ACTIONS_MENU: true
  },
  [EDITOR]: {
    HIDE_DELETE_MEMBER: true,
    HIDE_SUSPEND_MEMBER: true,
    HIDE_REACTIVATE_MEMBER: true
  },
  [NO_ACCESS]: {
    HIDE_CREATE_MEMBER: true
  }
};
